module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-bold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-bold-webfont.eot
// module id = 90
// module chunks = d-game